import { Routes } from "@angular/router";
import { AuthGuard } from "app/@core/auth-guard.service";

export const routes: Routes = [
  {
    path: "courses",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("app/courses/courses.routes").then((m) => m.COURSES_ROUTES),
  },
  {
    path: "course",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("app/course/course.routes").then((m) => m.COURSE_ROUTES),
  },
  {
    path: "auth",
    loadChildren: () =>
      import("app/auth/auth.routes").then((m) => m.AUTH_ROUTES),
  },
  {
    path: "admin",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("app/admin/admin.routes").then((m) => m.ADMIN_ROUTES),
  },
  { path: "", redirectTo: "auth/login", pathMatch: "full" },
  { path: "**", redirectTo: "courses/my-courses" },
];
